export enum AddMeasurementsResults {
    None = 0,
    MeasurementTransactionOk = 1,
    LabelNotFound = 2,
    BoxtypeNotFound = 4,
    WeightNotMeasured = 8,
}
